import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

const TOKEN_KEY = "ld_admin_token";

// sessionStorage: token is cleared when the browser session ends, reducing
// the exposure window compared to localStorage.
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

// Public
export const createEnquiry = (data) => api.post("/enquiries", data);
export const getGallery = () => api.get("/gallery");
export const getProducts = () => api.get("/products");

// Auth
export const login = (password) => api.post("/auth/login", { password });

// Admin
export const getEnquiries = () => api.get("/enquiries", { headers: authHeaders() });
export const deleteEnquiry = (id) => api.delete(`/enquiries/${id}`, { headers: authHeaders() });
export const addGallery = (data) => api.post("/gallery", data, { headers: authHeaders() });
export const deleteGallery = (id) => api.delete(`/gallery/${id}`, { headers: authHeaders() });
export const updateProduct = (id, data) => api.put(`/products/${id}`, data, { headers: authHeaders() });
